export function invalidateWalletBalance(queryClient, chainId) {
    return queryClient.invalidateQueries({
        // invalidate any walletBalance queries for this chainId
        // TODO: add wallet address in here if we can get it somehow
        queryKey: chainId ? ["walletBalance", chainId] : ["walletBalance"],
    });
}
//# sourceMappingURL=invalidateWalletBalance.js.map